module.exports = __webpack_public_path__ + "img/4.03a107ee.jpg";